<div class="suggested-points__interests_filter">  
  <ci-chip-set 
    overflow
    multiselect
    (change)="handleSelectedInterest($event)"
    >
    @for(interest of interestListChip(); track interest.id) {
      <ci-filter-chip-outline
        [chip]="interest"
        [value]="interest.id"
        [attr.data-value]="interest.id"
      >
        <span slot="label">
          {{ interest.label }}
        </span>
      </ci-filter-chip-outline>
    }
  </ci-chip-set>
</div>